export default __webpack_public_path__ + "img/main.default.small.4274e1e6.png";